import React from "react";
import { computed, observable } from "mobx";
import { observer } from "mobx-react";

import ClearIcon from "@material-ui/icons/Clear";
import { SearchRounded } from "@material-ui/icons";

import { IconButton, InputBase } from "@material-ui/core";

import { Container, InputWrapper } from "./styles";

type Props = {
  initValue?: string;
  placeholder?: string;
  onChange?: (value: string) => void;
  onApply?: (value: string) => void;
  onClear?: () => void;
  className?: any;
  disabled?: boolean;
};

@observer
class Search extends React.Component<Props> {
  @observable value: string = "";
  @observable appliedValue: string = "";
  @observable isSelected: boolean = false;

  inputRef: React.RefObject<HTMLInputElement> = React.createRef();

  @computed
  get isEmpty() {
    return !this.value;
  }

  get input() {
    return this.inputRef && this.inputRef.current;
  }

  componentDidMount() {
    this.value = this.props.initValue ?? "";
    this.isSelected = !this.isEmpty;
  }

  componentDidUpdate(prevProps: Props) {
    if (prevProps.initValue && !this.props.initValue) {
      this.clearInput();
    }
  }

  onChange = (
    e: React.ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    const { onChange } = this.props;
    this.value = e.target.value;
    onChange && onChange(this.value);
  };

  apply = () => {
    const { onApply } = this.props;

    this.isSelected = !this.isEmpty;
    this.appliedValue = this.value;
    onApply && onApply(this.value);
    this.blurInput();
  };

  clearInput = () => {
    this.isSelected = false;
    this.value = "";
    this.appliedValue = "";
    this.blurInput();
  };

  clear = () => {
    const { onClear } = this.props;
    this.clearInput();
    onClear && onClear();
  };

  onKeyDown = (
    event: React.KeyboardEventHandler<HTMLTextAreaElement | HTMLInputElement>,
  ) => {
    if (event.key === "Enter") {
      this.apply();
    }
  };

  blurInput = () => {
    this.input && this.input.blur();
  };

  render() {
    const { placeholder, className, disabled } = this.props;

    return (
      <Container className={className}>
        <InputWrapper>
          <InputBase
            value={this.value}
            onChange={this.onChange}
            placeholder={placeholder ?? "Search"}
            onKeyDown={this.onKeyDown}
            ref={this.inputRef}
            disabled={disabled}
          />
          <IconButton
            onClick={this.isSelected ? this.clear : this.apply}
            disabled={disabled}
          >
            {this.isSelected ? <ClearIcon /> : <SearchRounded />}
          </IconButton>
        </InputWrapper>
      </Container>
    );
  }
}

export default Search;
